import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_BID_PROFILE } from '../../store/bidProfile';
import { UPDATE_DRAFT_BID_PROFILE } from '../../store/bidProfileDraft';
/**
 * @param {number} bidConfigurationIndex
 */
const useSelectTab = (bidConfigurationIndex) => {
    const dispatch = useDispatch();

    /** @type {ShiftBidding.ManagerStore} */
    // @ts-ignore
    const { bidProfile, bidProfileDraft } = useSelector((state) => state);
    const [selectedTab, setTab] = useState(bidConfigurationIndex);

    const ACTION_TYPE = bidProfileDraft.id !== '' ? UPDATE_DRAFT_BID_PROFILE : UPDATE_BID_PROFILE;
    const profile = bidProfileDraft.id !== '' ? bidProfileDraft : bidProfile;

    /** @param {number} newSelection */
    const setSelectedTab = (newSelection) => {
        setTab(newSelection);
        dispatch({
            type: ACTION_TYPE,
            payload: {
                tabSelected: newSelection,
            },
        });
    };

    useEffect(() => setSelectedTab(profile.tabSelected), [profile.tabSelected]);
    return { selectedTab, setSelectedTab };
};

export default useSelectTab;
